
import $ from 'jquery';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import Toasted from 'vue-toasted';
import { KanbanState } from '../../kanban.model';
import Spinner from '../../../util/Spinner';
import { handleError } from '../../../../api';

Vue.use(Toasted, { duration: 2000 });

@Component({
  name: 'MassSelectDeleteConfirmModal',
  components: {
    Spinner,
    vSelect,
  },
})
export default class MassSelectDeleteConfirmModal extends Vue {
  @Prop({ required: true })
  readonly state!: KanbanState;

  saving: boolean = false;

  public open(): void {
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }

  async save(): Promise<void> {
    this.saving = true;
    try {
      for (let card of this.state.massSelectionCards) {
        try {
          await this.state.cardsAPI.delete(card.id!);

          //remove card from model
          let board = this.state.boards?.find(b => b.tickets?.some(t => t.id === card.ticketId));
          let flow = board?.tickets?.find(e => e.id === card.ticketId);
          if (flow) {
            let index = (flow.cards ?? []).findIndex(e => e.id === card.id);
            if (index > -1) {
              flow.cards?.splice(index, 1);
            }
          }
        } catch (e) {
          handleError(this.$toasted, this.$i18n, e);
        }
      }
      this.state.massSelectionCards.splice(0);
      this.state.massSelectionEnabled = false;
      
      this.$toasted.info(this.$t('kanban.massSelect.delete.confirmModal.deleted').toString());
      this.dismiss();
    } finally {
      this.saving = false;
    }
  }
}
